module.exports = __webpack_public_path__ + "static/media/horizontalSuitcase.fb13e306.svg";